/**
 * Inizializza i componenti Javascript del sistema.
 * Ogni componente si presenta in forma di funzione
 * con jQuery come unico parametro.
 */

import addressing from './component/addressing';
import ajax from './component/ajax';
import calendar from './component/calendar';
import carousel from './component/carousel';
import clipboard from './component/clipboard';
import checkboxButton from './component/checkbox-button';
import dropdown from './component/dropdown';
import errorHandler from './component/error-handler';
import facebook from './component/facebook';
import gallery from './component/gallery';
import maps from './component/maps';
import misc from './component/misc';
import modal from './component/modal';
import radioButton from './component/radio-button';
import recaptcha from './component/recaptcha';
import responsive from './component/responsive';
import scroll from './component/scroll';
import sticky from './component/sticky';
import timer from './component/timer';
import toggle from './component/toggle';
import tooltip from './component/tooltip';
import upload from './component/upload';
import insurance from './component/insurance';
import scripts from './scripts/main';

window.app.env = window.app.env || 'prod';

const boot = () => {
  if (window.app.env === 'dev') {
    errorHandler(jQuery);
  }

  addressing(jQuery);
  ajax(jQuery);
  calendar(jQuery);
  carousel(jQuery);
  clipboard(jQuery);
  checkboxButton(jQuery);
  dropdown(jQuery);
  facebook(jQuery);
  gallery(jQuery);
  modal(jQuery);
  radioButton(jQuery);
  responsive(jQuery);
  recaptcha(jQuery);
  scroll(jQuery);
  sticky(jQuery);
  timer(jQuery);
  toggle(jQuery);
  tooltip(jQuery);
  upload(jQuery);
  insurance(jQuery);
  misc(jQuery);
  // Carica le mappe dopo, perché in sviluppo se ci sono errori (ad esempio
  // manca la gmaps key) blocca tutto ciò che viene dopo
  maps(jQuery);

  // Altri componenti specifici delle pagine
  scripts(jQuery);
};

jQuery(boot);



// WEBPACK FOOTER //
// ./assets/js/index.js